import React, { Component } from 'react';
import propTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import axios from 'axios';
import 'react-day-picker/lib/style.css';
import ApiConfig from '../../../config'
import ZipApi from '../../../zips'

import numberImg from '../../../assets/icons/black/number.png';
import calendarImg from '../../../assets/icons/black/calendar.png';
import sortImg from '../../../assets/icons/black/sort.png';
import exit from '../../../assets/icons/black/exit.png';

export default class ModuleMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      levelValue: this.props.level,
      statusValue: this.props.status,
      zipView: 'field',
      searchZip: this.props.zip,
      searchDistance: '10',
      zipK: (ZipApi()),
      foundZips: {},
    }
  }

  levelChange = e => {this.setState({levelValue: e.target.value});}
  statusChange = e => {this.setState({statusValue: e.target.value});}

  findZips = e => {
    console.log(e);

    // foundZips
    let propedURL = 'https://airmagic.herokuapp.com/' + e;


    delete axios.defaults.headers.common["Authorization"];
    axios.get(propedURL, {headers: {
      "Authorization": 'Bearer ' + ApiConfig()
    }})
      .then(response => {
        console.log(response.data.zip_codes);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + ApiConfig();
        this.setState({
          foundZips: response.data.zip_codes,
        });



        setTimeout((function() {
          let newZips = [];
          for (var i in this.state.foundZips) {
            newZips.push(this.state.foundZips[i]);
          }


          let allZips = this.state.foundZips + ', ' + this.props.area;
          allZips = allZips.replace(/ /g,'').split(',');

          let finalZips = [...new Set(allZips)];
          console.log('Current: ' + this.props.area);

          finalZips = finalZips + '';

          this.props.updateCoverageArea(finalZips);

          this.switchZipView('field');
        }).bind(this), 50);
      });
  }

  changeZip = e => {
    this.setState({
      searchZip: e.target.value,
    });
  }

  changeDistance = e => {
    this.setState({
      searchDistance: e.target.value,
    });
  }

  switchZipView = (e) => {
    this.setState({
      zipView: e,
    })
  }

  componentDidMount() {
    setTimeout((function() {
      this.setState({
        levelValue: this.props.level,
        statusValue: this.props.status,
      })
    }).bind(this), 50);
  }

  // Render
  // ----------------------------------------------------
  render() {
    let area = this.props.area;
    let spName = this.props.spName;
    let company = this.props.company;
    let ein = this.props.ein;
    let volumeDate = this.props.volumeDate;
    let language = this.props.language;
    let status = this.props.status;
    let level = this.props.level;
    let zip = this.props.zip;
    let spNumber = this.props.spNumber;


    return (
      <div className="ModuleCard">
        <div className="inner">

          <div className="inputBlock inputBlock--small">
            <label>SP #</label>
            <input
              type="text"
              onChange={this.props.changeRecordHandler}
              value={spNumber}
              id="spNumber"
            />
          </div>
          <div className="inputBlock inputBlock--large">
            <label>SP Name</label>
            <input
              type="text"
              onChange={this.props.changeRecordHandler}
              value={spName}
              id="spName"
            />
          </div>

          <div className="inputBlock inputBlock--half">
            <label>Status</label>
            <div
              className="selectBlock"
              id="status"
              >
              <select id="statusSelect" value={this.state.statusValue} onChange={this.statusChange}>
                <option id="none"></option>
                <option id="Prospect">Prospect</option>
                <option id="Active">Active</option>
                <option id="Inactive">Inactive</option>
                <option id="Former">Former</option>
                <option id="Transfer">Transfer</option>
                <option id="Not+Interested">Not Interested</option>
                <option id="Looking+for+Work">Looking for Work</option>
                <option id="New+Lead">New Lead</option>
              </select>
            </div>
          </div>
          <div className="inputBlock inputBlock--half">
            <label>Level</label>
            <div
              className="selectBlock"
              id="level"
              >
              <select id="levelSelect" value={this.state.levelValue} onChange={this.levelChange}>
                <option id="none"></option>
                <option id="1">1</option>
                <option id="2">2</option>
                <option id="3">3</option>
                <option id="4">4</option>
                <option id="5">5</option>
              </select>
            </div>
          </div>

          <div className="inputBlock inputBlock--half">
            <label>Company Name</label>
            <input
              type="text"
              value={company}
              id="company"
              onChange={this.props.changeRecordHandler}
            />
          </div>
          <div className="inputBlock inputBlock--half">
            <label>EIN Number</label>
            <div className="inputWithTag">
              <div className="inputTag">
                <img src={numberImg} />
              </div>
              <input
                type="text"
                id="ein"
                value={ein}
                onChange={this.props.changeRecordHandler}
              />
            </div>
          </div>

          <div className="inputBlock inputBlock--half">
            <label>Volume Due</label>
            <div className="inputWithTag">
              <div className="inputTag" onClick={this.props.calcVolume}>
                <img src={sortImg} />
              </div>
              <input
                type="text"
                id="volumeDate"
                value={volumeDate}
                onChange={this.props.changeRecordHandler}
              />
            </div>
          </div>
          <div className="inputBlock inputBlock--half">
            <label>Languages</label>
            <input
              type="text"
              value={language}
              id="language"
              onChange={this.props.changeRecordHandler}
            />
          </div>

          <hr />


          {this.zipView}
        </div>
      </div>
    );
  }



  get zipView() {
    let area = this.props.area;
    let zip = this.props.zip;

    if (this.state.zipView === 'field') {
      return (
        <div className="inputBlock inputBlock--full">
          <div>
            <label>Zip Code Coverage</label>
            <input
              type="text"
              value={area}
              id="area"
              onChange={this.props.changeRecordHandler}
            />
          </div>
          <a onClick={()=>this.switchZipView('search')}>Generate Zips Close to Home</a>
        </div>
        )
    } else if (this.state.zipView === 'search') {
      let zipURL = 'https://www.zipcodeapi.com/rest/' + this.state.zipK + '/radius.json/' + this.state.searchZip + '/' + this.state.searchDistance + '/mile?minimal';

      return (
        <div className="inner zipSearch">
          <img src={exit} className="backBtn" alt="exit"onClick={()=>this.switchZipView('field')} />
          <div className="inputBlock inputBlock--third">
            <label>Zips Near</label>
            <input
              type="text"
              id="zipSearch"
              value={this.state.searchZip}
              onChange={this.changeZip}
            />
          </div>

          <div className="inputBlock inputBlock--third">
            <label>Within (miles)</label>
            <input
              type="text"
              id="searchDistance"
              value={this.state.searchDistance}
              onChange={this.changeDistance}
            />
          </div>

          <div className="inputBlock inputBlock--small submitButton">
            <input
              type="submit"
              value="Search"
              onClick={()=>this.findZips(zipURL)}
            />
          </div>
        </div>
        )
    }
  }
}

ModuleMain.propTypes ={
  spName: propTypes.string,
  spNumber: propTypes.string,
  status: propTypes.string,
  level: propTypes.string,
  company: propTypes.string,
  ein: propTypes.string,
  volumeDate: propTypes.string,
  language: propTypes.string,
  calcVolume: propTypes.func.isRequired,
  changeRecordHandler: propTypes.func.isRequired,
  changeSelectBlock: propTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/Franchisees/Records/Modules/ModuleMain.js